import React, { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { Box, IconButton } from "@mui/material";
import SettingsOutlined from "@mui/icons-material/SettingsOutlined";
import MachineLogoIcon from "../../../shared/assets/icons/MachineLogoIcon";
import AccessDeniedNotification from "./AccessDeniedNotification";
import Loader from "../../../shared/components/Loader";
import { useAppSelector } from "../../../shared/hooks/sharedHooks";
import { PublicState } from "../../publicSlice";
import { useRedesignSetup } from "../../../shared/hooks/useRedesignSetup";
import { dt } from "../../../shared/themes/redesignTokens";

const KIOSK_STYLE_ID = "kiosk-keyframes";

const Layout = () => {
  const { isAccessDenied } = useAppSelector((state: any) => state.accessDenied);
  const { machine } = useAppSelector<PublicState>((state: any) => state.public);
  const navigate = useNavigate();

  useRedesignSetup();

  // Inject kiosk-specific keyframes
  useEffect(() => {
    if (!document.getElementById(KIOSK_STYLE_ID)) {
      const style = document.createElement("style");
      style.id = KIOSK_STYLE_ID;
      style.textContent = `
        @keyframes tileEnter {
          from { opacity: 0; transform: scale(0.9); }
          to { opacity: 1; transform: scale(1); }
        }
      `;
      document.head.appendChild(style);
    }
  }, []);

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: "1023px",
        mx: "auto",
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        backgroundColor: dt.pageBg,
        backgroundImage: `radial-gradient(circle at 1px 1px, ${dt.pageDotColor} 1px, transparent 0)`,
        backgroundSize: "28px 28px",
        fontFamily: dt.font,
        "& *:not(.MuiSvgIcon-root)": { fontFamily: dt.font },
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          px: 2,
          py: 2,
          minHeight: "64px",
          position: "relative",
        }}
      >
        <MachineLogoIcon />
        <IconButton
          onClick={() => {
            const machineId = machine?.internalNumber;
            if (machineId) {
              navigate(`/public/machines/${machineId}/settings`);
            }
          }}
          sx={{
            position: "absolute",
            right: 12,
            top: "50%",
            transform: "translateY(-50%)",
            color: dt.textSecondary,
            padding: "8px",
            "&:hover": { backgroundColor: dt.blueSoft, color: dt.blue },
          }}
        >
          <SettingsOutlined sx={{ fontSize: "22px" }} />
        </IconButton>
      </Box>

      <Box sx={{ px: 0, pb: 4, flex: 1 }}>
        {isAccessDenied ? <Loader /> : <Outlet />}
      </Box>

      <AccessDeniedNotification />
    </Box>
  );
};

export default Layout;
